<div class="details-panel" [ngClass]="{ 'fullscreen': isFullscreen }">
  <!-- Panel Header -->
  <div class="panel-header">
   <h3 class="panel-title">
      Details Panel
      <span class="entity-name" *ngIf="selectedEntity">
        <i class="material-icons">table_chart</i>
        <span class="entity-text">{{ selectedEntity.entityName }}</span>
      </span>
    </h3>
    <button 
      class="fullscreen-toggle-btn" 
      (click)="onToggleFullscreen()"
      [title]="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'">
      <i class="material-icons">
        {{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}
      </i>
    </button>
  </div>

  <!-- Panel Content -->
  <div class="panel-content">
    <!-- Tabs Section -->
    <div class="tabs-section">
      <div class="tabs-container" [style.--active-tab-index]="getActiveTabIndex()">
        <button 
          *ngFor="let tab of tabs; let i = index" 
          class="tab-button"
          [class.active]="tab.active"
          (click)="selectTab(tab.id)">
          <i class="material-icons tab-icon">{{ tab.icon }}</i>
          <span class="tab-label">{{ tab.label }}</span>
        </button>
        <div class="tab-indicator"></div>
      </div>
      
      <!-- Tab Content Area -->
      <div class="tab-content-area">
        <!-- Edit Row Tab -->
        <app-edit-row-tab class="tab-content-item" *ngIf="selectedTab === 'EditRow'"></app-edit-row-tab>

        <!-- Dedup Tab -->
        <app-dedup-tab class="tab-content-item" [hidden]="selectedTab !== 'Dedup'"></app-dedup-tab>
        
        <!-- Relations Tab -->
        <app-relations-tab class="tab-content-item" *ngIf="selectedTab === 'Relations'"></app-relations-tab>
        
        <!-- Sources Tab -->
        <app-sources-tab class="tab-content-item" *ngIf="selectedTab === 'Sources'"></app-sources-tab>
        
        <!-- MapIt Tab -->
        <app-map-it-tab class="tab-content-item" *ngIf="selectedTab === 'MapIt'"></app-map-it-tab>
        
        <!-- Refresh Tab -->
        <app-refresh-tab class="tab-content-item" *ngIf="selectedTab === 'Refresh'"></app-refresh-tab>
        
        <!-- ChatIT Tab -->
        <app-chat-it-tab class="tab-content-item" *ngIf="selectedTab === 'ChatIT'"></app-chat-it-tab>
      </div>
    </div>

  </div>
</div>
